import { render } from "./SendSms.vue?vue&type=template&id=b9f371d6&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"

import "./SendSms.vue?vue&type=style&index=0&id=b9f371d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f371d6"]])

export default __exports__